/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {SortDirection} from './sort-direction';
/**
 * To modify the labels and text displayed, create a new instance of MdSortHeaderIntl and
 * include it in a custom provider.
 */
export class MdSortHeaderIntl {
/**
 * Stream that emits whenever the labels here are changed. Use this to notify
 * components if the labels have changed after initialization.
 */
changes: Subject<void> = new Subject<void>();
/**
 * ARIA label for the sorting button.
 */
sortButtonLabel = (id: string) => {
    return `Change sorting for ${id}`;
  }
/**
 * A label to describe the current sort (visible only to screenreaders).
 */
sortDescriptionLabel = (id: string, direction: SortDirection) => {
    return `Sorted by ${id} ${direction == 'asc' ? 'ascending' : 'descending'}`;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdSortHeaderIntl_tsickle_Closure_declarations() {
/** @type {?} */
MdSortHeaderIntl.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdSortHeaderIntl.ctorParameters;
/**
 * Stream that emits whenever the labels here are changed. Use this to notify
 * components if the labels have changed after initialization.
 * @type {?}
 */
MdSortHeaderIntl.prototype.changes;
/**
 * ARIA label for the sorting button.
 * @type {?}
 */
MdSortHeaderIntl.prototype.sortButtonLabel;
/**
 * A label to describe the current sort (visible only to screenreaders).
 * @type {?}
 */
MdSortHeaderIntl.prototype.sortDescriptionLabel;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
